<template lang="html">
  <dt class="definition-term">
    <Headline :size="1">
      <slot />
    </Headline>
  </dt>
</template>

<script>
import Headline from 'beisheim/components/elements/headline'

export default {
  components: {
    Headline
  }
}
</script>

<style lang="scss">
@import '~beisheim/scss/scale';

.definition-term {
  margin-top: scale(5);
}
</style>
